<template lang="html">
  <div id="description-page">
    <LoadingComponent v-if="isLoading"></LoadingComponent>

    <section class="breadcrumb-section" v-if="!isLoading">
      <div class="container oversized-container">
        <span>Producto</span>
        <span class="line">/</span>
        <span>{{ product.name }}</span>
      </div>
    </section>

    <section class="container oversized-container description-section" id="product-description" v-if="!isLoading">
      <div class="row">

        <div class="col-lg-6 col-gallery" v-if='!icecat'>
          <swiper :options="galleryOptions" v-if="gallery.length > 0">
            <swiper-slide v-for="(row, galIndex) in gallery" :key="galIndex">
              <div class="image-container">
                <div class="img">
                  <!-- <img :src="row" class="w-100"> -->
                  <v-zoom :img="row" :width="'100%'"></v-zoom>
                </div>
              </div>
            </swiper-slide>

            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>

          <!-- <div class="box-video">
            <iframe src="https://www.youtube.com/embed/yQ_vtTTukq4?si=Aad3F_WR6QZEyEtf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div> -->
        </div>

        <b-form class="mt-3 mt-lg-0 col-lg-6 col-description" @submit.prevent="quantityValidate()">
          <h1 class="mb-2 name">{{ product.name }}</h1>
          <!-- <h4 class="price discount"><span>$ {{ product.price }}</span></h4> -->
          <!-- <h4 class="price f-w-700 old-price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.oldPrice) }}</h4>
          <h4 class="price f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h4> -->
          <div class="b-short-description">
            <!-- <h6><span class="label">Potecia</span> <span class="txt-1">6 HP a 24,000 RPM’s</span></h6>
            <h6><span class="label">Area util</span> (X)1220 x (Y) 2440 X (Z) 200 mm</h6>
            <h6><span class="label">Velocidad de avance</span> 35,000 mm/min</h6>
            <h6><span class="label">Precisión +/-</span> 0.15 mm</h6> -->

            <div class="descr" v-html="product.short_description">
            </div>

            <p class="mt-3 extra-breadcrumb">
              <span><strong class="f-w-600">Categoria: </strong> <a class="buble" target="_blank">{{ product.category.name }}</a> <br /></span>
            </p>
          </div>

          <div class="mt-3 mb-3 accordion-no-border" role="tablist">
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-1>CARACTERÍSTICAS <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <!-- <p class="mt-2 extra-breadcrumb">
                    <span><strong class="f-w-600">SKU: </strong> {{ product.sku }}<br /></span>
                  </p> -->

                  <div class="box-categories-brands">
                    <!-- <p class="mt-2 extra-breadcrumb" v-if="product.marca">
                      <span><strong class="f-w-600">Marca:</strong></span> <router-link class="buble" target="_blank"  :to="'/marca/'+$root._converToURL(product.marca, product.marca_id)"> {{ product.marca }}</router-link>
                    </p> -->
                  </div>

                  <div class="txt-description">
                    <!-- <p>
                      Conoce los beneficios y propiedades de nuestra cinta de máxima calidad.
                    </p> -->

                    <div class="box-features" v-html="product.description"></div>
                    <!-- <div class="box-features" v-html="product.description">
                      <ul class="check-list">
                        <li>
                          <h6>La línea Azalea.</h6>
                          <p>ReciclaLa ventaja más importante es que.</p>
                        </li>
                      </ul>
                    </div> -->
                  </div>

                  <!-- <div class="mt-1 extra-breadcrumb">
                    <span v-if="product.ancho"><strong>Ancho:</strong> {{ product.ancho }} metros. </span>
                    <span v-if="product.alto"><strong>Alto:</strong> {{ product.alto }} metros. </span>
                    <span v-if="product.largo"><strong>Largo:</strong> {{ product.largo }} metros. </span>
                    <span v-if="product.volumen"><strong>Volumen:</strong> {{ product.volumen }}. </span>
                    <span v-if="product.peso"><strong>Peso:</strong> {{ product.peso }} kg. </span>
                    <span v-if="product.material"><strong>Material:</strong> {{ product.material }}.</span>
                  </div> -->
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>

          <!-- <div class="mt-1 extra-breadcrumb" v-if="product.ancho">Ancho: {{ product.ancho }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.alto">Alto: {{ product.alto }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.largo">Largo: {{ product.largo }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.volumen">Volumen: {{ product.volumen }}</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.peso">Peso: {{ product.peso }} kg</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.material">Material: {{ product.material }}</div> -->

          <h6 class="mt-2 subtitle" v-if="product.ficha">Ficha tecnica</h6>
          <div class="txt-description" v-if="product.ficha" v-html="product.ficha"></div>

          <h6 class="subtitle" v-if="product.color">Color</h6>
          <h4 class="price" v-if="product.color">{{ product.color }}</h4>

          <!-- Stock -->
          <!-- <div class="mt-2 extra-breadcrumb">
            <span><strong>Disponibilidad:</strong> En existencias</span>
          </div> -->

          <div v-if="product.table.length">
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-2>MEDIDAS <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="pb-2">
                    <div class="pt-1 text-center">
                      <table id="stocktable" class="w-100">
                        <template v-for="(row, rowInx) in product.table">
                          <thead v-if="row.is_bold == 1">
                            <tr>
                              <th class="br-gray" v-if="product.n_measures_columns >= 1" :colspan="joinColumns(row.is_row)">{{ row.a1 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 2 && row.is_row != 1">{{ row.a2 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 3 && row.is_row != 1">{{ row.a3 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 4 && row.is_row != 1">{{ row.a4 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 5 && row.is_row != 1">{{ row.a5 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 6 && row.is_row != 1">{{ row.a6 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 7 && row.is_row != 1">{{ row.a7 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 8 && row.is_row != 1">{{ row.a8 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 9 && row.is_row != 1">{{ row.a9 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 10 && row.is_row != 1">{{ row.a10 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 11 && row.is_row != 1">{{ row.a11 }}</th>
                              <th class="br-gray" v-if="product.n_measures_columns >= 12 && row.is_row != 1">{{ row.a12 }}</th>
                            </tr>
                          </thead>

                          <tbody v-else>
                            <tr>
                              <td v-if="product.n_measures_columns >= 1" :colspan="joinColumns(row.is_row)">
                                <a class="link" @click="openInfoModal(row.a1_modal)" v-if="row.a1_modal">{{ row.a1 }}</a>
                                <span v-else>{{ row.a1 }}</span>
                              </td>
                              <td v-if="product.n_measures_columns >= 2 && row.is_row != 1">{{ row.a2 }}</td>
                              <td v-if="product.n_measures_columns >= 3 && row.is_row != 1">{{ row.a3 }}</td>
                              <td v-if="product.n_measures_columns >= 4 && row.is_row != 1">{{ row.a4 }}</td>
                              <td v-if="product.n_measures_columns >= 5 && row.is_row != 1">{{ row.a5 }}</td>
                              <td v-if="product.n_measures_columns >= 6 && row.is_row != 1">{{ row.a6 }}</td>
                              <td v-if="product.n_measures_columns >= 7 && row.is_row != 1">{{ row.a7 }}</td>
                              <td v-if="product.n_measures_columns >= 8 && row.is_row != 1">{{ row.a8 }}</td>
                              <td v-if="product.n_measures_columns >= 9 && row.is_row != 1">{{ row.a9 }}</td>
                              <td v-if="product.n_measures_columns >= 10 && row.is_row != 1">{{ row.a10 }}</td>
                              <td v-if="product.n_measures_columns >= 11 && row.is_row != 1">{{ row.a11 }}</td>
                              <td v-if="product.n_measures_columns >= 12 && row.is_row != 1">{{ row.a12 }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </table>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <!-- <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-3>PREGUNTAS FRECUENTES <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="d-block py-1">
                      <div class="d-block b-faqs" v-for="(f, fInx) in 6">
                        <h6 class="f-w-600">
                          Pregunta en preguntas frecuentes {{ fInx + 1 }}
                        </h6>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi laborum.
                        </p>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div> -->

          <div v-if="product.document">
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-4>DESCARGAS <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="row pb-1">
                      <div class="col-lg-6 col-download py-2">
                        <a class="w-100 btn btn-outline" target="_blank" :href="product.document">ARCHIVO PDF</a>
                      </div>

                      <!-- <div class="col-lg-6 col-download py-2">
                        <a class="w-100 btn btn-outline" href="">CERTIFICADO</a>
                      </div> -->
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <!-- <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-5>VIDEO <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="box-video">
                      <iframe src="https://www.youtube.com/embed/yQ_vtTTukq4?si=Aad3F_WR6QZEyEtf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div> -->
          <!--  -->

          <!-- <h4 class="pt-2 price f-w-700">Desde $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} más IVA</h4> -->

          <h6 class="mt-3 subtitle">Compartir</h6>
          <div class="col-12 mt-1 col-extra col-networks" id="col-extra">
            <div class="row">
              <!-- <div class="col b-print">
                <div class="btn-q" @click="printDiv('product-description')"><span><i class="fas fa-print"></i></span></div>
              </div> -->

              <div class="col px-0 b-sharing">
                <ShareNetwork
                  v-for="(network, pdInx) in networks"
                  :network="network.network"
                  :key="network.network"
                  :style="{backgroundColor: network.color}"
                  :url="sharing.url"
                  :title="sharing.title"
                  :description="sharing.description"
                  :quote="sharing.quote"
                  :hashtags="sharing.hashtags"
                  :twitterUser="sharing.twitterUser">
                  <div class="btn-q"><span><i :class="network.icon"></i></span></div>
                </ShareNetwork>

              </div>
            </div>
          </div>

          <div class="row mt-4 row-quantity-button">
            <!-- <div class="col-lg col-quantity">
              <h6 class="subtitle" v-if="product.stock">Cantidad</h6>
              <div class="row no-gutters pt-1 box-options" v-if="product.stock">
                <div class="col col-short">
                  <b-form-input v-model="form.quantity" type="number" class="text-center" required></b-form-input>
                </div>
              </div>
            </div> -->

            <!-- <div class="col-lg pl-lg-0 mt-3 mt-lg-2 col-btn-send">
              <b-button type="submit" class="w-100 btn-submit">COMPRAR <i class="fa-solid fa-cart-shopping"></i></b-button>
            </div> -->

            <!-- <div class="col-12 col-btn-send mb-3">
              <a class="w-100 btn btn-submit c2">DESDE $ <span class="f-w-700">{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</span> MÁS IVA</a>
            </div> -->

            <div class="col-12 col-btn-send">
              <router-link class="w-100 btn btn-submit c1" to="/contacto">SOLICITAR COTIZACIÓN</router-link>
            </div>
          </div>

          <div class="d-block mt-4 mb-2" v-if="product.pdf">
            <a class="btn btn-submit btn-contact" v-if="product.pdf" :href="product.pdf" target="_blank" rel="noopener noreferrer">PDF <i class="fa fa-file-pdf-o"></i></a>
          </div>

          <div class="col-12 my-2">
            <div class="row">
              <div class="col-sm-6 my-2 px-0 pr-sm-3" v-if="product.stock">
                <!-- <b-button type="submit" class="w-100 btn-submit">AGREGAR AL CARRITO <i class="fa-solid fa-cart-shopping"></i></b-button> -->
              </div>

              <div class="col-sm-6 my-2 px-0 pl-sm-3">
                <!-- <router-link class="w-100 btn btn-submit btn-contact" :to="{ name: 'contacto', query: { p: product.name+', SKU: '+product.sku } }">Contactar <i class="far fa-envelope"></i></router-link> -->
              </div>
            </div>
          </div>

          <!-- <h6 class="subtitle">Inventarios</h6>
          <div class="col-12 mt-2 col-extra" id="col-extra">
            <table id="stocktable">
                <tr>
                  <th>Almacen</th>
                  <th>Stock</th>
                </tr>
                <tr v-for="(st,indx) in product.stocks" :key="indx">
                  <td>{{st.warehouse}}</td>
                  <td>{{st.stock}}</td>
                </tr>
            </table>
          </div> -->
        </b-form>

        <!-- <div class="col-12 mb-2">
          <div class="col-12 px-0 col-s-title">
            <h2 class="title">Comentarios</h2>
            <hr class="mt-2 mb-0" />
          </div>
        </div> -->

        <!-- <div class="col-lg-6 col-comment-form">
          <div class="col-12 col-comments">
            <b-form class="box-comment" @submit="addComment">
              <h5 class="subt">Califica este producto</h5>

              <div class="box-stars">
                <b-form-rating inline required v-model="comment.stars" stars="5"></b-form-rating>
              </div>

              <div class="box-input">
                <b-form-textarea v-model="comment.body" placeholder="Escribe tu comentario" required rows="2" max-rows="2"></b-form-textarea>

                <p class="mt-2 text-right">
                  <b-button type="submit" class="btn-co">Comentar</b-button>
                </p>
              </div>
            </b-form>
          </div>
        </div>

        <div class="col-lg-6 mt-3 col-all-comments">
          <div class="wr-comments" v-if="comments.length">
            <div class="row">

              <div class="col-12 col-total-comments" v-if="avg > 0">
                <div class="box"><small>TOTAL:</small> {{ Math.ceil(avg) }}</div>
              </div>

              <div class="col-12 col-comments">
                <div class="row">
                  <div class="col-lg-6 col-comment" v-for="(item, coprInx) in comments" :key="'coprInx-'+coprInx">
                    <div class="box">
                      <div class="box-stars">
                        <b-form-rating v-model="item.star" readonly inline></b-form-rating>
                      </div>

                      <div class="box-comment">{{ item.comment }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-11 mx-auto col-extrainfo" v-if="icecat">
            <div id="Container5"></div>
            <div id="Container7"></div>
            <div id="Container11"></div>
        </div> -->

      </div>

    </section>

    <section class="container oversized-container related-products-section" id="related-products" v-if="!isLoading">
      <div class="row">
        <div class="col-12 px-2 col-s-title">
          <h2 class="text-center title">OTROS PRODUCTOS</h2>
          <hr class="mt-2 mb-2" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-0 col-products">
          <swiper class="swiper carousel-t1" :options="productsOption">
            <swiper-slide v-for="(p, pInx) in products" :key="'pInx-'+pInx">
              <div class="col-12 px-0 box-product-s1">
                <router-link class="box-link" :to="'/producto/'+p.id">
                  <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+p.image+')' }">
                    <img src="public/images/shared/empty.png">
                  </div>

                  <div class="box-info">
                    <h5 class="title">{{ p.name }}</h5>

                    <!-- <h5 class="price">DESDE ${{ p.price }}</h5> -->
                  </div>
                </router-link>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>

    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
      <div v-html="modal.msg"></div>
      <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Agregar mas productos</b-button>
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
      </div>
    </sweet-modal>

    <b-modal modal-class="modal-info" ref="modal-info" size="lg" centered hide-footer title="">
      <LoadingComponent v-if="isModalLoading"></LoadingComponent>

      <div class="box-info" v-else>
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <a class="p-2" v-b-toggle.accordion-mo-1>{{ modalInfo.title }}</a>
            </b-card-header>

            <b-collapse id="accordion-mo-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div class="box-description">
                  <div class="col-lg-5 col-image">
                    <img v-if="modalInfo.imageUrl" :src="modalInfo.imageUrl">
                  </div>

                  <div class="col-lg-7 col-short-info">
                    <p>
                      {{ modalInfo.description }}
                    </p>

                    <div class="b-table table-responsive-lg">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th class="br">Código</th>
                            <th>Descripción</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td class="br">{{ modalInfo.code }}</td>
                            <td>{{ modalInfo.title }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="b-table table-responsive-lg">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th colspan="2" class="br">Diámetro</th>
                            <th colspan="2" class="br">Altura</th>
                            <th colspan="2" class="br">Base</th>
                            <th colspan="2" class="br">Peso</th>
                            <th colspan="2" class="br">Volumen</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <th>Cm</th>
                            <th class="br">Plg.</th>
                            <th>Cm</th>
                            <th class="br">Plg.</th>
                            <th>Cm</th>
                            <th class="br">Plg.</th>
                            <th>Grs:</th>
                            <th class="br">Lbs.</th>
                            <th>Lts</th>
                            <th>gal.</th>
                          </tr>
                          <tr>
                            <td>{{ modalInfo.diameter_cm }}</td>
                            <td class="br">{{ modalInfo.diameter_in }}</td>
                            <td>{{ modalInfo.height_cm }}</td>
                            <td class="br">{{ modalInfo.height_in }}</td>
                            <td>{{ modalInfo.base_cm }}</td>
                            <td class="br">{{ modalInfo.base_in }}</td>
                            <td>{{ modalInfo.weight_g }}</td>
                            <td class="br">{{ modalInfo.weight_lb }}</td>
                            <td>{{ modalInfo.volume_l }}</td>
                            <td>{{ modalInfo.volume_gal }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <a class="p-2" v-b-toggle.accordion-mo-2>Paquetes</a>
            </b-card-header>
            <b-collapse id="accordion-mo-2" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div class="box-description">
                  <div class="col-lg-5 col-image">
                    <img v-if="modalInfo.packageImageUrl" :src="modalInfo.packageImageUrl">
                  </div>

                  <div class="col-lg-7 col-short-info">
                    <p>
                      {{ modalInfo.package_description }}
                    </p>

                    <div class="b-table table-responsive-lg">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th class="br">Piezas x empaque</th>
                            <th class="br" colspan="6">Dimensiones del paquete</th>
                            <th class="br" colspan="2">Peso paquete</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <th class="br" rowspan="3">{{ modalInfo.package_pieces }}</th>
                            <th>Largo</th>
                            <th>Ancho</th>
                            <th class="br">Alto</th>
                            <th>Largo</th>
                            <th>Ancho</th>
                            <th class="br">Alto</th>
                            <th rowspan="2">Kgs:</th>
                            <th rowspan="2">Lbs:</th>
                          </tr>

                          <tr>
                            <th>cm.</th>
                            <th>cm.</th>
                            <th class="br">cm.</th>
                            <th>Plg.</th>
                            <th>Plg.</th>
                            <th class="br">Plg.</th>
                          </tr>

                          <tr>
                            <td>{{ modalInfo.pkg_long_cm }}</td>
                            <td>{{ modalInfo.pkg_wide_cm }}</td>
                            <td class="br">{{ modalInfo.pkg_height_cm }}</td>
                            <td>{{ modalInfo.pkg_long_in }}</td>
                            <td>{{ modalInfo.pkg_wide_in }}</td>
                            <td class="br">{{ modalInfo.pkg_height_in }}</td>
                            <td>{{ modalInfo.pkg_kg }}</td>
                            <td>{{ modalInfo.pkg_lb }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <a class="p-2" v-b-toggle.accordion-mo-3>Colores</a>
            </b-card-header>
            <b-collapse id="accordion-mo-3" accordion="my-accordion" role="tabpanel">
              <b-card-body class="px-1 pb-2">
                <div class="box-colors">
                  <div class="b-color" v-for="(c, cInx) in modalInfo.colors" :key="'cInx-'+cInx">
                    <div class="circle" v-bind:style="{ backgroundColor: c.color_code }"></div>
                    <span class="text">{{ c.name }}</span>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <!-- <h3 class="modal-title">Maceta Azalea 6"</h3> -->
      </div>
    </b-modal>

  </div>
</template>

<script>
import vZoom from 'vue-zoom'; // https://www.npmjs.com/package/vue-zoom
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {vZoom, LoadingComponent},

  data() {
    return {
      id: null,
      isLoading: true,

      form: {
        quantity: 1,
      },

      gallery: [
        // 'public/images/pages/products/product-1.jpg',
        // 'public/images/pages/products/product-1.jpg',
      ],

      product: {
        id: 2,
        name: 'Maceta tipo 1',
        sku: 'OD52SD0SR',
        category_id: '5',
        category: 'Maceta de cultivo',
        subcategory_id: '5',
        subcategory: 'Macra colgante',
        price: '460333',
        oldPrice: '0',
        marca_id: 1,
        marca: 'PPI ',
        description: '<p>Las macetas tipo Azalea para cultivo son ligeras, resistentes, durables y económicas por que están fabricadas con Polipropileno que es un copolimero de alto impacto que les da una gran resistencia a los golpes, rasguños y luz solar, estas características constituyen la razón para que sean utilizadas en horticultura, viveros de plantas ornamentales y cultivo de plantas de temporada.</p>',
        stock: 35,
        ancho: 3,
        alto: 2.6,
        largo: 5,
        peso: 999.90,
        stocks:[],
      },
      category: [],
      products: [
        { imageUrl: 'public/images/pages/products/product-2.jpg', price: '119', title: 'Maceta de muestra tipo 2' },
        { imageUrl: 'public/images/pages/products/product-3.jpg', price: '99', title: 'Maceta de muestra tipo 3' },
        { imageUrl: 'public/images/pages/products/product-4.jpg', price: '80', title: 'Maceta de muestra tipo 4' },
        { imageUrl: 'public/images/pages/products/product-10.jpg', price: '109', title: 'Maceta de muestra tipo 5' },
      ],
      sizes: [],
      size: [],
      stock: 0,
      avg: 0,
      favorite: false,
      icecat: false,

      isModalLoading: true,
      modalInfo: {
        title: 'Cargando...',
      },

      // == Sharing ==
      sharing: {
        url: 'https://ppi.com.mx/#/producto/',
        title: 'PPI',
        description: 'Esto es un ejemplo de descripción',
        quote: 'Esto es el Quote',
        hashtags: 'this,isthe,hashtag',
        twitterUser: 'twitter'
      },

      networks: [
        { network: 'twitter', name: 'Twitter', icon: 'fa-brands fa-x-twitter' },
        { network: 'facebook', name: 'Facebook', icon: 'fab fa-facebook-f' },
        { network: 'email', name: 'Email', icon: 'fas fa-envelope' },
        { network: 'whatsapp', name: 'WhatsApp', icon: 'fab fa-whatsapp' },
      ],
      // == ==

      colors: [],

      relatedProducts: [],

      comments: [],

      modal:{
        msg:'',
        icon:'',
        block:false
      },

      comment:{
        stars: null,
        body: ''
      },

      // == Carrusel options ==
      galleryOptions: {
        loop: false,
        speed: 600,

        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // }
      },

      productsOption: {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 0,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          992: {
            slidesPerView: 3
          },
          768: {
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: 'slide',
        speed: 600
      },
      // == ==
    }
  },

  watch: {
    "$route.params.id" : function(v){
      //this.id = this.$route.params.id;
      this.id = this.$root._getURLID(this.$route.params.id);
      this.getProduct();
    }
  },

  methods:{
    toast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      })
    },

    openInfoModal(idx) {
      this.modalInfo = {};
      this.isModalLoading = true;
      this.$refs['modal-info'].show();
      
      axios.get(tools.url('/api/products/measure-details/'+idx)).then((response)=>{
        this.modalInfo = response.data;
        this.isModalLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },

    copyLink(value) {
      navigator.clipboard.writeText(value);
      // alert('Link copiado');
      this.toast('Pago seguro ', 'Link copiado correctamente', 'success');
    },

    getComments(id) {
      axios.get(tools.url('/api/comments/'+id)).then((response)=>{
        this.comments = response.data.comments;
        this.avg = response.data.avg;

      }).catch((error)=>{
        console.log(error);
      })
    },

    addComment: function() {
        axios.post(tools.url("/api/comments/"+this.product.id),{stars:this.comment.stars, comment:this.comment.body}).then((response) => {
            this.comment.stars = null;
            this.comment.body = '';
            this.getComments(this.id);
        }).catch((error) => {
            alert("Error al agregar comentario");
            console.log(error);
        })
    },

    quantityValidate() {
        if(this.form.quantity > this.product.stock){
            if(this.product.stock <= 1){ w = 'pieza' };
            this.toast('Error', 'Este artículo cuenta con maximo '+this.product.stock+' '+w+' en existencia', 'danger');
        }else{
            this.stock = this.product.stock;
            this.addCart();
        }
    },

    getProduct() {
      this.isLoading = true;

      axios.get(tools.url('/api/products/' + this.id)).then((response)=>{
        this.product = [];
        this.gallery = [];
        this.product = response.data;
        this.category = response.data.category;
        this.gallery = response.data.gallery;
        this.isLoading = false;

        if(this.product.stock > 0){
          this.form.quantity = 1;
        }

        this.getRelated(this.product.id);
        //this.getComments(this.product.id);
      }).catch((error)=>{
        console.log(error);
      });
    },

    addCart() {
      var cart = [];
      var encontrado = false;

      if(this.form.quantity > 0){
          if(localStorage.cart){
            cart = JSON.parse(localStorage.getItem('cart'));

            for(var i = 0; i < cart.length ; i++){
              if(cart[i].id == this.id){
                var suma = Number(cart[i].quantity) + Number(this.form.quantity);
                cart[i].quantity = suma <= this.stock ? suma : this.stock;
                encontrado = true;
                break;
              }
            }

            if(!encontrado){
              cart.push({ id:this.id, quantity:this.form.quantity });
            }
          } else{
            cart.push({ id:this.id, quantity:this.form.quantity });
          }

          localStorage.setItem("cart",JSON.stringify(cart));
          this.$root.cartCount = cart.length;
          this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito con '+this.form.quantity+' piezas';
          this.modal.icon = 'success';
          this.$refs.modal.open();
      }
    },

    getRelated(id) {
      axios.get(tools.url('/api/products/related/'+id)).then((response)=>{
        this.products = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    getFavorite: function() {
        if(this.$root.user.id){
            axios.post(tools.url('/api/favorite'),{ product_id: this.id }).then((response)=>{
                if(response.data == 'true'){
                    this.favorite = true;
                }else{
                    this.favorite = false;
                }
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    addFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/addFavorite'),{product_id: this.id }).then((response)=>{
                this.favorite = response.data.favorite;
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    favoritesCount: function(){
        if(this.$root.user.id){
            axios.get(tools.url('/api/favoritesCount')).then((response)=>{
                this.$root.favoriteCount = response.data;
            }).catch((error)=>{
                console.log(error);
            })
        }
    },

    joinColumns(status) {
      if(status) {
        return this.product.n_measures_columns;
      }
    },
  },

  mounted(){
    this.id = this.$route.params.id;
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getProduct();

    /*if(this.$root.logged == true){
        this.getFavorite();
    }*/
  }
}
</script>
